import React from 'react'
import { IoCallOutline } from "react-icons/io5";

function ExpertCallingCard({ expert }) {
  const handleCall = () => {
    const phone = expert.mobile || expert.phone;
    if (phone) window.location.href = `tel:${phone}`;
  };

  return (
    <div className="activity-item" style={{ padding: '8px 12px', background: '#F9FAFB' }}>
      <div className="activity-avatar" style={{ background: 'rgba(249, 115, 22, 0.1)', color: '#F97316' }}>
        {(expert.name || expert.customer_name || 'E')[0].toUpperCase()}
      </div>
      <div className="activity-content">
        <div className="activity-title" style={{ fontSize: '13px' }}>
          {expert.name || expert.customer_name || 'Unknown'}
        </div>
        <div className="activity-subtitle" style={{ fontSize: '11px' }}>
          {expert.mobile || expert.phone || 'N/A'}
        </div>
      </div>
      <button className="btn-secondary" style={{ padding: '6px', minWidth: '32px' }} onClick={handleCall}>
        <IoCallOutline size={14} />
      </button>
    </div>
  );
}

export default ExpertCallingCard
